export { default } from './Work';
